export default "__VITE_ASSET__eLYo8$aW__"